module.exports = __webpack_public_path__ + "img/space_ex_heading.ae081d7c.png";